const GOOGLE_SHEETS_ORIGIN = 'https://docs.google.com';

export function getGoogleSheetEmbedUrl(sheetUrl: string): string | null {
  try {
    const parsed = new URL(sheetUrl);
    const parts = parsed.pathname.split('/').filter(Boolean);
    const sheetId = parts[0] === 'spreadsheets' && parts[1] === 'd' ? parts[2] : null;

    if (parsed.origin !== GOOGLE_SHEETS_ORIGIN || !sheetId) return null;

    return `${GOOGLE_SHEETS_ORIGIN}/spreadsheets/d/${encodeURIComponent(sheetId)}/edit?rm=minimal&embedded=true`;
  } catch {
    return null;
  }
}
